import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRoot } from "../../context/RootProvider";
import { LOGIN_ROUTE } from "../../routes/routePaths";

export interface IProtectedComponentProps {
  children: React.ReactNode;
  allowed?: string[];
  extraInfo?: any;
}

const ProtectedComponent: React.FC<IProtectedComponentProps> = ({
  children,
}) => {
  const { auth } = useRoot();
  if (!auth?._id) {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }

  return <>{children || <Outlet />}</>;
};

export default ProtectedComponent;
